import { filter, map, Observable, of, switchMap, tap, zip } from 'rxjs'

/**
 * Check loaded
 * @param loaded$ the slice's loded property e.g. this.purchasesFacade.loaded$
 * @returns source action once the provided loaded observable returns true
 */

export function gbCheckLoaded<Action>(
  loaded$: Observable<boolean | string | object | undefined>,
  showLoader = () => {},
  hideLoader = () => {},
): (source$: Observable<Action>) => Observable<Action> {
  return (source$) =>
    source$.pipe(
      tap(showLoader),
      switchMap((action) => {
        return zip([of(action), loaded$.pipe(filter((loaded) => !!loaded))]).pipe(
          tap(hideLoader),
          map(([action, loaded]) => action),
        )
      }),
    )
}
